import { ga4Destination } from "./ga4";
import { rebelbaseDestination } from "./rebelbase";
import type { Destination } from "./types";

/**
 * Every sink events can reach, in delivery order.
 *
 * This list is the whole routing configuration. To send a new event type to only
 * one destination, adjust that destination's `accepts`. To add a sink, add it
 * here — no call site changes, because nothing calls a destination directly.
 */
export const DESTINATIONS: Destination[] = [ga4Destination, rebelbaseDestination];

export type { Destination } from "./types";
